import { useEffect } from 'react'

import { useAiChat } from '@factorialco/f0-react'

import { useOne, useOneFeatureAvailable } from 'modules/ai/lib/useOne'
import { useActivity } from 'modules/core/lib/activities/activity'

type Props = {
  disruptedShiftId: string
}

export const OpenOneShiftReplacementActivity = ({ disruptedShiftId }: Props) => {
  const oneAvailable = useOneFeatureAvailable()
  const { open, closeActivity } = useActivity()
  const { open: isChatOpen } = useAiChat()

  useEffect(() => {
    if (!oneAvailable || !isChatOpen) {
      return
    }

    closeActivity()
  }, [closeActivity, isChatOpen, oneAvailable])

  useOne(
    ['shiftManagement'],
    { disruptedShiftId, source: 'shift_replacement_notification' },
    {
      autoOpenChat: true,
      coCreationKey: `shift-replacement-${disruptedShiftId}`,
      enabled: oneAvailable,
    }
  )

  if (!open) {
    return null
  }

  return null
}
